"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldLayoutThreeColumn = exports.FieldLayoutTwoColumn = exports.FieldLayoutSmall = exports.FieldDivWrapper = exports.FieldWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _fieldAttrsUtils = require("../microFields/fieldAttrsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* layout component - strictly to wrap field components with required html attrs */
var FieldWrapper = function FieldWrapper(_ref) {
  var fieldName = _ref.fieldName,
      children = _ref.children,
      isSmall = _ref.isSmall,
      cashbotName = _ref.cashbotName,
      cashbotOptions = _ref.cashbotOptions;
  return _react.default.createElement("div", (0, _fieldAttrsUtils.fieldContainerAttributes)({
    fieldName: fieldName,
    isSmall: isSmall,
    cashbotName: cashbotName,
    cashbotOptions: cashbotOptions
  }), children);
};

exports.FieldWrapper = FieldWrapper;
FieldWrapper.defaultProps = {
  cashbotOptions: {},
  isSmall: false
};
FieldWrapper.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  cashbotOptions: _propTypes.default.object,
  children: _propTypes.default.node.isRequired,
  isSmall: _propTypes.default.bool
};
/* layout component - if the fields need a div for relative positioning
 * this is only needed if we need to absolutely position child getNumberIcon or similar
*/

var FieldDivWrapper = function FieldDivWrapper(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: "field-group__div"
  }, children);
};

exports.FieldDivWrapper = FieldDivWrapper;
FieldDivWrapper.propTypes = {
  children: _propTypes.default.node.isRequired
};
/*
 * FieldLayoutSmall & FieldLayoutTwoColumn expect children to be one of:
 * InputGroup or SelectGroup components (these can be passed into Field)
 * takes care of fluid styling for the field
*/

/*
 * wrapper to make a single field smaller
*/

var FieldLayoutSmall = function FieldLayoutSmall(_ref3) {
  var children = _ref3.children,
      xSmall = _ref3.xSmall,
      isCentered = _ref3.isCentered;
  var containerClass = (0, _dedupe.default)({
    'field-container--small': !xSmall,
    'field-container--xsmall': xSmall,
    'field-container--center': isCentered
  });
  return _react.default.createElement("div", {
    className: containerClass
  }, children);
};

exports.FieldLayoutSmall = FieldLayoutSmall;
FieldLayoutSmall.defaultProps = {
  isCentered: false,
  xSmall: false
};
FieldLayoutSmall.propTypes = {
  children: _propTypes.default.node.isRequired,
  isCentered: _propTypes.default.bool,
  xSmall: _propTypes.default.bool
};
/*
 * pass 2 children
 * 1st child will be on the left
 * 2nd child will be on the right
 * smaller screen sizes : fields will be stacked into a single column
 * mobileFullWidth to make the two column fields full width on small screens
 * asymmetrical to make two columns have different widths
*/

var FieldLayoutTwoColumn = function FieldLayoutTwoColumn(_ref4) {
  var children = _ref4.children,
      mobileFullWidth = _ref4.mobileFullWidth,
      asymmetrical = _ref4.asymmetrical;
  var containerClass = (0, _dedupe.default)('field-container--two_col', {
    'field-container--full': mobileFullWidth,
    'field-container--asymmetrical': asymmetrical
  });
  return _react.default.createElement("div", {
    className: containerClass
  }, children);
};

exports.FieldLayoutTwoColumn = FieldLayoutTwoColumn;
FieldLayoutTwoColumn.defaultProps = {
  mobileFullWidth: false,
  asymmetrical: false
};
FieldLayoutTwoColumn.propTypes = {
  children: _propTypes.default.node.isRequired,
  mobileFullWidth: _propTypes.default.bool,
  asymmetrical: _propTypes.default.bool
};
/**
 * pass 3 children
 * positioned in order from left to right
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */

var FieldLayoutThreeColumn = function FieldLayoutThreeColumn(_ref5) {
  var children = _ref5.children;
  return _react.default.createElement("div", {
    className: "field-container--three_col"
  }, children);
};

exports.FieldLayoutThreeColumn = FieldLayoutThreeColumn;
FieldLayoutThreeColumn.propTypes = {
  children: _propTypes.default.node.isRequired
};